import { useGetPermissions } from 'layouts/customHook';
import React from 'react';
import { useHistory } from "react-router";
import { ReactComponent as CashRefund } from "assets/img/svg/Group 30.svg";
import { getScreenCards } from "views/pages/manage/finOps/IssueStock/search/SearchCard";

const PaymentManagementConfig = () => {
    const PaymentManagementPermissions = useGetPermissions('paymentManagementConfig')
    const CashControlPermissions = useGetPermissions('cashControlConfig');
    const PaymentApprovalPermissions = useGetPermissions('paymentManagementApprovalConfig');
    const history = useHistory();

    const cards = [
        ...(PaymentApprovalPermissions.length ? [{
            heading: "Payment management approval config",
            subHeading: "Modify roles and access",
            icon: <CashRefund />,
            action: () => {
                history.push("/admin/pmApprovalConfig");
            },
        }] : []),
        ...(CashControlPermissions.length ? [{
            heading: "Cash Control Config",
            subHeading: "Control the Cash deposition days",
            icon: <CashRefund />,
            action: () => {
                history.push("/admin/cashControlConfig");
            },
        }] : []),
    ]
    return (
        <>
            <div className={`screen-cards-container`}>{getScreenCards(cards)}</div>
        </>
    );
}

export default PaymentManagementConfig;